<template>
	<tr>
		<td>
			<span>{{ ip }}</span>
		</td>
		<td>
			<span>{{ blockedStr }}</span>
		</td>
		<td>
			<span>{{ lastUpdate }}</span>
		</td>
		<td>
			<span>{{ updater }}</span>
		</td>
		<td class="actions">
			<ToggleBlockAction
				:blocked="blocked"
				:updating="updating"
				@block="block"
				@unblock="unblock"
			/>
		</td>
	</tr>
</template>

<script>
import ToggleBlockAction from '@/components/admin/ToggleBlockAction'

export default {
	name: 'BlockedIPsTableRow',
	props: {
		ip: String,
		blocked: Boolean,
		updatedBy: Object,
		updated_at: String,
		updating: Boolean
	},
	computed: {
		blockedStr() {
			return this.blocked ? 'Yes' : 'No'
		},
		lastUpdate() {
			return new Date(this.updated_at).toLocaleDateString()
		},
		updater() {
			return this.updatedBy.username
		}
	},
	methods: {
		block() {
			this.$emit('block', { ip: this.ip })
		},
		unblock() {
			this.$emit('unblock', { ip: this.ip })
		}
	},
	components: {
		ToggleBlockAction
	}
}
</script>
